import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { internalMessageBus } from "sb-internal-msg-bus";
import { BaseDict } from "./dict";
import { config } from "./config";
import { AggregatesScoresBlock } from "./ui/AggregatesScoresBlock";
import { AggregatesScoresBlockState } from "./state";
/*
    This structure allows us to use mocks during dev
    but not to include them when we do build:release
*/
// import * as MOCKSTYPE from "../../mocks";
// let _: typeof MOCKSTYPE;
// let AggregatesDataMock;
if (process.env.NODE_ENV === "development") {
    // _ = require("../../mocks");
    // AggregatesDataMock = _.AggregatesDataMock;
}
export class AggregatesScoresBlockRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
        navHandler: {},
        dataProvider: {},
        betSlipUtil: {},
        oddsUtil: {},
        facade: {},
        gameStatus: {},
        timeControl: {},
        panelId: "",
        storageUtils: {},
        userInfo: {}
    }) {
        super(domId, options);
        // init of dataProvider for test environment is needed because ViewPresenterBlock calls ScoresBlock.activate in componentDidMount
        /* tslint:disable:cyclomatic-complexity */
        if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test") {
            // setup data mocks for debug build
            this.dataProvider = new AggregatesScoresBlockState(internalMessageBus);
            //export data store to window for debug purposes
            window["AggregatesScoresBlockState"] = this.dataProvider;
            // window["AggregatesIncidentsDataMock"] = new AggregatesDataMock(internalMessageBus);
            // window["AggregatesIncidentsDataMock"].activate();
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use dataProvider - internalMessageBus passed during the construction from the
            // mobile application page method
            this.dataProvider = new AggregatesScoresBlockState(options.dataProvider);
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        // merge default and CMS options
        this.options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
    }
    activate() {
        this.dataProvider.activate();
        return super.activate(React.createElement(AggregatesScoresBlock, { dataProvider: this.dataProvider, dict: this.options.dict }));
    }
    deactivate() {
        this.dataProvider.deactivate();
        // if (process.env.NODE_ENV === "development") {
        //     window["AggregatesIncidentsDataMock"].deactivate();
        // }
        return super.deactivate();
    }
}
window["AggregatesScoresBlock"] = AggregatesScoresBlockRoot;
broadcastBlockLoad("AggregatesScoresBlock");
//# sourceMappingURL=index.js.map